import { render } from "./reviewHistoryGZCQ.vue?vue&type=template&id=6a25863d"
import script from "./reviewHistoryGZCQ.vue?vue&type=script&lang=js"
export * from "./reviewHistoryGZCQ.vue?vue&type=script&lang=js"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__